import {
  AxiosError,
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';

import ENVIRONMENT from '@/environments/environment';
import InsightService from '@/services/insights';

import { onResponseError } from './responseInterceptors';

const onRequest = async (config: InternalAxiosRequestConfig<any>) => {
  const token = sessionStorage.getItem('accessToken');
  // El cambio de clave caducada se hace sin sesión, con las mismas credenciales que el token
  if (config.url?.includes('v2/token') || config.url?.includes('api-security/v2/change-password')) {
    config.headers.Authorization = `Basic ${btoa(`${ENVIRONMENT.DATA_PROVIDER_SECURITY.API_KEY}:${ENVIRONMENT.DATA_PROVIDER_SECURITY.API_SECRET}`)}`;
    return config;
  }
  // if (config.url?.includes('/reset-password')) {
  //   config.headers.Authorization = `Bearer ${btoa(`${ENVIRONMENT.DATA_PROVIDER_SECURITY.API_KEY}:${ENVIRONMENT.DATA_PROVIDER_SECURITY.API_SECRET}`)}`;
  //   return config;
  // }
  config.headers.Authorization = `Bearer ${token}`;
  return config;
};

const onRequestError = (error: AxiosError) => Promise.reject(error);

const onResponse = (response: AxiosResponse) => {
  InsightService.logEvent('Request', [
    {
      request: {
        requestURL: response.request?.responseURL,
        config: response.config,
      },
    },
    { response: response.data },
  ]);
  return response.data;
};

export function setupInterceptorsTo(
  axiosInstance: AxiosInstance,
): AxiosInstance {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}
